module.exports = __webpack_public_path__ + "img/sharelogo.bdacdd41.png";